import { PayloadAction } from "@reduxjs/toolkit";

// Use this action type in combination with rehydrateReducer to rehydrate persisted slice states
export const REHYDRATE = "rehydrate";
export const rehydrateReducer = <T>(state: T, action: PayloadAction<T>) => {
  if (action.payload === undefined) return state;
  return action.payload;
};
